import { render, staticRenderFns } from "./AutoIndentConfirmationDialog.vue?vue&type=template&id=96666a5a&scoped=true"
import script from "./AutoIndentConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./AutoIndentConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./AutoIndentConfirmationDialog.vue?vue&type=style&index=0&id=96666a5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96666a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96666a5a')) {
      api.createRecord('96666a5a', component.options)
    } else {
      api.reload('96666a5a', component.options)
    }
    module.hot.accept("./AutoIndentConfirmationDialog.vue?vue&type=template&id=96666a5a&scoped=true", function () {
      api.rerender('96666a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/AutoIndentConfirmationDialog.vue"
export default component.exports